<template>
  <div>
    <v-card
      v-if="selectedItems.length > 0"
      class="pa-4 mb-2"
      style="box-shadow: none; border-bottom: thin solid rgba(0, 0, 0, 0.12); border-radius: 0px"
    >
      <div style="justify-content: right; display: flex">
        <div class="mr-4" style="width: 280px">
          <v-select
            v-model="newStatus"
            :items="statusOptions"
            label="Chọn trạng thái cần cập nhật"
            outlined
            dense
            hide-details
            clearable
          />
        </div>
        <div style="align-content: center; text-align-last: right">
          <v-btn color="primary" @click="changeStatusForSelected">
            <v-icon left>mdi-check</v-icon>
            Chuyển trạng thái
          </v-btn>
        </div>
      </div>
    </v-card>
    <v-data-table
      :class="{ 'hide-student-columns': !canDisplayByStudent, 'hide-student-columns2': canDisplayByStudent }"
      v-bind="this.$attrs"
      loading-text="Đang Tải"
      item-key="id"
      :headers="headers"
      :items="uniformOrderss"
      :loading="loading"
      no-data-text="Không có dữ liệu"
      :footer-props="{
        'items-per-page-text': 'Hiển thị mỗi trang',
        'items-per-page-all-text': 'Tất cả',
        'items-per-page-options': uniformOrderss.length > 100 ? [10, 20, 30] : [15, 25, -1],
      }"
      disable-sort
      show-select
      item-value="id"
      v-model="selectedItems"
      class="custom-data-table"
    >
      <!-- Checkbox chọn tất cả -->
      <template v-slot:header.columnName="{ props }">
        <v-checkbox
          :indeterminate="selectedItems.length > 0 && selectedItems.length < uniformOrderss.length"
          :value="selectedItems.length === uniformOrderss.length"
          @change="toggleSelectAll"
        />
      </template>
      <!-- Order -->
      <template v-slot:[`item.orderedAt`]="{ item }" v-if="canDisplayByStudent">
        <div class="table-cell-wrapper2">
          {{ formatMonthYear(item.orderedAt) }}
        </div>
      </template>

      <!-- Học sinh -->
      <template v-slot:[`item.student`]="{ item }" v-if="!canDisplayByStudent">
        <div class="table-cell-wrapper2">
          <CardStudentName :student="item.student" link style="padding: 0px !important" />
        </div>
      </template>

      <!-- Ngày sinh -->
      <template v-slot:[`item.student.dob`]="{ item }" v-if="!canDisplayByStudent">
        <div class="table-cell-wrapper">{{ item.student.dob | ddmmyyyy }}</div>
      </template>

      <!-- Giới tính-->
      <!-- <template v-slot:[`item.student.gender`]="{ item }">{{ item.student.gender | gender }}</template> -->

      <!-- Lớp -->
      <template v-slot:[`item.student.class`]="{ item }" v-if="!canDisplayByStudent">
        <div class="table-cell-wrapper">
          <router-link style="text-decoration: none" :to="'/class/' + item.student.class.id">
            <span>{{ item.student.class.title }}</span>
          </router-link>
        </div>
      </template>

      <!-- Nội dung đơn -->
      <template v-slot:[`item.uniformItems`]="{ item }">
        <div class="table-cell-wrapper">
          <div v-if="item.uniformItems && item.uniformItems.length">
            <div v-for="(uni, index) in item.uniformItems" :key="index">
              <div>{{ uni.name }} - {{ uni.optionOne }} - {{ uni.optionTwo }} ({{ uni.quantity }})</div>
              <v-divider v-if="index < item.uniformItems.length - 1" class="my-1" />
            </div>
          </div>
        </div>
      </template>

      <!-- Ghi chú của phụ huynh -->
      <template v-slot:[`item.note`]="{ item }">
        <div style="white-space: nowrap; overflow: hidden; text-overflow: ellipsis" class="table-cell-wrapper">
          {{ item.note || '-' }}
        </div>
      </template>

      <!-- Tổng tiền -->
      <template v-slot:[`item.totalPrice`]="{ item }">
        <div class="table-cell-wrapper" style="justify-self: right">{{ formatCurrency(item.totalPrice) }}</div>
      </template>

      <!-- Trạng thái đơn -->
      <template v-slot:[`item.status`]="{ item }">
        <div class="table-cell-wrapper">
          <v-chip small class="white--text" label :color="getStatusColor(item.status)">
            {{ getStatusText(item.status) }}
          </v-chip>
        </div>
      </template>

      <!-- Trạng thái trả -->
      <template v-slot:[`item.statusReturned`]="{ item }">
        <div class="table-cell-wrapper">
          <v-chip small class="white--text" label :color="getStatusReturnColor(item.statusReturned)">
            {{ getStatusReturnText(item.statusReturned) }}
          </v-chip>
        </div>
      </template>

      <!-- Đối soát trả -->
      <template v-slot:[`item.returnTracking`]="{ item }">
        <div class="table-cell-wrapper">
          <div v-if="item.uniformItems && item.uniformItems.length">
            <div v-for="(uni, index) in item.uniformItems" :key="index">
              <div>
                {{ uni.name }} - {{ uni.optionOne }} - {{ uni.optionTwo }} ({{ uni.returned }}/{{ uni.quantity }})
              </div>
              <v-divider v-if="index < item.uniformItems.length - 1" class="my-1" />
            </div>
          </div>
        </div>
      </template>

      <!-- Thao tác -->
      <template v-slot:[`item.actions`]="{ item }">
        <div class="table-cell-wrapper">
          <!-- <v-btn @click="onEdit(item)" icon><v-icon left>mdi-pencil</v-icon></v-btn>
        <v-icon
          color="primary"
          @click="viewOrderDetail(item.id)"
        >
          mdi-information-outline
        </v-icon> -->

          <v-btn @click="onDetailOrder(item)" icon color="primary">
            <v-icon>mdi-eye-outline</v-icon>
          </v-btn>
          <v-btn
            @click="canDisplayByStudent ? onConfirmStudentOrder(item) : onConfirmOrder(item)"
            icon
            color="primary"
            v-if="
              $auth.policies['confirm-uniform-orders'] ||
              (canDisplayByStudent && canDisplayByStudent && item.status === 'pending')
            "
          >
            <v-icon>mdi-checkbox-marked-circle-outline</v-icon>
          </v-btn>
          <v-btn
            @click="onReviewOrder(item)"
            icon
            color="primary"
            v-if="$auth.policies['returned-uniform-orders'] && !canDisplayByStudent"
          >
            <v-icon>mdi-cube-send</v-icon>
          </v-btn>

          <v-menu offset-y>
            <template v-slot:activator="{ on, attrs }">
              <v-btn v-bind="attrs" v-on="on" icon>
                <v-icon>mdi-dots-vertical</v-icon>
              </v-btn>
            </template>
            <v-list>
              <v-list-item>
                <v-list-item-title
                  style="cursor: pointer; width: 40px"
                  :style="{
                    cursor: 'pointer',
                    width: $auth.policies['delete-uniform-orders'] ? '40px' : '',
                  }"
                  @click="onShowHistory(item)"
                >
                  <v-icon>mdi-clock-alert-outline</v-icon>
                </v-list-item-title>
                <v-list-item-title
                  v-if="$auth.policies['delete-uniform-orders'] && !canDisplayByStudent"
                  style="cursor: pointer; border-left: thin solid rgba(0, 0, 0, 0.12); padding-left: 10px"
                  @click="onRemove(item)"
                >
                  <v-icon>mdi-delete</v-icon>
                </v-list-item-title>
              </v-list-item>
            </v-list>
          </v-menu>
        </div>
      </template>
    </v-data-table>

    <!-- Dialog xác nhận -->
    <DetailOrderDialog
      :state="detailDialog"
      :uniformOrderData="selectedItem"
      @updated="refresh(uniformOrdersSearchParams)"
    />

    <!-- Dialog xác nhận học sinh -->
    <ConfirmStudentOrderDialog
      :state="confirmStudentDialog"
      :uniformOrderData="selectedItem"
      @updated="refresh(uniformOrdersSearchParams)"
    />

    <!-- Dialog xác nhận -->
    <ConfirmOrderDialog
      :state="confirmDialog"
      :uniformOrderData="selectedItem"
      @updated="refresh(uniformOrdersSearchParams)"
    />

    <!-- Dialog đối soát -->
    <ReviewOrderDialog
      :state="reviewDialog"
      :uniformOrderData="selectedItem"
      @updated="refresh(uniformOrdersSearchParams)"
    />

    <HistoryDialog
      :state="historyDialog"
      :uniformOrderData="selectedItem"
      @close="historyDialog = false"
      @updated="refresh(uniformOrdersSearchParams)"
    />

    <v-dialog v-model="confirmDialogSelect" width="500">
      <v-card>
        <v-toolbar color="primary" dark>
          <v-toolbar-title>Thông báo</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn icon @click="confirmDialogSelect = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-toolbar>
        <v-card-text class="pt-4">
          <template v-if="itemsSkipped.length === 0">
            Bạn có chắc chắn muốn chuyển trạng thái cho <strong>{{ selectedItems.length }}</strong> đơn này thành
            <strong>{{ getStatusText(newStatus) }}</strong
            >?
          </template>

          <template v-else>
            Trong danh sách bạn chọn có tồn tại <strong>{{ itemsSkipped.length }}</strong> đơn đăng ký đang hoặc đã trả
            hàng. Các đơn này sẽ không được thay đổi trạng thái. Bạn có thể hủy thao tác và kiểm tra lại thay vì tiếp
            tục.<br />
            Nếu tiếp tục, bạn có chắc chắn muốn chuyển trạng thái cho
            <strong>{{ itemsToUpdate.length }}</strong> đơn còn lại thành <strong>{{ getStatusText(newStatus) }}</strong
            >?
          </template>
        </v-card-text>
        <v-divider />
        <v-card-actions class="pa-4">
          <v-btn color="red" style="color: white" @click="confirmChange">XÁC NHẬN</v-btn>
          <v-spacer />
          <v-btn outlined @click="confirmDialogSelect = false">HUỶ</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="confirmDialogSelectAlert" width="500">
      <v-card>
        <v-toolbar color="primary" dark>
          <v-toolbar-title>Thông báo</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn icon @click="confirmDialogSelectAlert = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-toolbar>
        <v-card-text class="pt-4">
          <template v-if="itemsSkipped.length === 0">
            Hệ thống đã cập nhật thành công trạng thái cho <strong>{{ selectedItems.length }}</strong> đơn thành
            <strong>{{ getStatusText(newStatus) }}</strong
            >.
          </template>
          <template v-else>
            Hệ thống đã cập nhật thành công trạng thái cho <strong>{{ itemsToUpdate.length }}</strong> đơn thành
            <strong>{{ getStatusText(newStatus) }}</strong
            >.
            <br />
            <strong>{{ itemsSkipped.length }}</strong> đơn đang hoặc đã trả hàng sẽ giữ nguyên trạng thái.
          </template>
        </v-card-text>
        <v-divider />
        <v-card-actions class="d-flex justify-space-between pa-6" style="justify-self: right">
          <v-btn outlined @click="confirmDialogSelectAlert = false">ĐÓNG</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!-- <ChangeUniformOrdersDialog :state="editDialog" :item="selectedItem" @updated="refresh(uniformOrdersSearchParams)" /> -->
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex'
import { get } from 'lodash'
import CardStudentName from '@/components/basic/card/CardStudentName.vue'
import ConfirmOrderDialog from '@/modules/uniformOrdersRegister/ConfirmOrderDialog.vue'
import ConfirmStudentOrderDialog from '@/modules/uniformOrdersRegister/ConfirmStudentOrderDialog.vue'
import ReviewOrderDialog from '@/modules/uniformOrdersRegister/ReviewOrderDialog.vue'
import HistoryDialog from '@/modules/uniformOrdersRegister/HistoryDialog.vue'
import DetailOrderDialog from '@/modules/uniformOrdersRegister/DetailOrderDialog.vue'

// const originHeaders = [
//   { text: 'Học sinh', value: 'student' },
//   { text: 'Ngày sinh', value: 'student.dob', width: 100 },
//   // { text: 'Giới tính', value: 'student.gender', width: 100 },
//   { text: 'Lớp', value: 'student.class', width: 20 },
//   { text: 'Nội dung đơn', value: 'uniformItems' },
//   { text: 'Ghi chú trên đơn', value: 'note', width: 80 },
//   { text: 'Tổng tiền', value: 'totalPrice' },
//   { text: 'Trạng thái đơn', value: 'status' },
//   { text: 'Trạng thái trả', value: 'statusReturned' },
//   { text: 'Đối soát trả', value: 'returnTracking' },
//   { text: 'Thao tác', value: 'actions' },
// ]

export default {
  components: {
    CardStudentName,
    ConfirmOrderDialog,
    ConfirmStudentOrderDialog,
    DetailOrderDialog,
    ReviewOrderDialog,
    HistoryDialog,
    // ChangeUniformOrdersDialog: () => import('@/modules/uniformOrdersRegister/ChangeUniformOrdersDialog.vue'),
  },
  data() {
    return {
      // headers: originHeaders,
      originHeaders: [
        { text: 'Đơn', value: 'orderedAt' },
        { text: 'Học sinh', value: 'student' },
        { text: 'Ngày sinh', value: 'student.dob', width: 100 },
        // { text: 'Giới tính', value: 'student.gender', width: 100 },
        { text: 'Lớp', value: 'student.class', width: 20 },
        { text: 'Nội dung đơn', value: 'uniformItems' },
        { text: 'Ghi chú trên đơn', value: 'note', width: 80 },
        { text: 'Tổng tiền', value: 'totalPrice' },
        { text: 'Trạng thái đơn', value: 'status' },
        { text: 'Trạng thái trả', value: 'statusReturned' },
        { text: 'Đối soát trả', value: 'returnTracking' },
        { text: 'Thao tác', value: 'actions' },
      ],
      tableOptions: {},
      editDialog: false,
      confirmDialog: false,
      confirmStudentDialog: false,
      detailDialog: false,
      confirmDialogSelect: false,
      confirmDialogSelectAlert: false,
      reviewDialog: false,
      historyDialog: false,
      selectedItem: {},
      selectedItems: [],
      itemsSkipped: [],
      itemsToUpdate: [],
      newStatus: '', // Trạng thái mới được chọn
      statusOptions: [
        { value: 'pending', text: 'Chờ duyệt', color: '#FFA726' },
        { value: 'confirmed', text: 'Đã xác nhận', color: '#4CAF50' },
        { value: 'cancelled', text: 'Đã hủy', color: '#616161' },
      ],
    }
  },
  methods: {
    ...mapActions('UniformOrdersRegister', [
      'getUniformOrdersRegisterByStudents',
      'removeUniformOrders',
      'updateUniformOrders',
    ]),
    formatMonthYear(dateStr) {
      if (!dateStr) return 'Đơn'
      const parts = dateStr.split(', ')
      if (parts.length !== 2) return 'Đơn'

      const [day, month, year] = parts[0].split('/')
      if (!day || !month || !year) return 'Đơn'

      return `Đơn ${month.padStart(2, '0')} / ${year}`
    },
    async refresh(query) {
      query = query || {}
      if (get(this.$auth.user, 'role.type') === 'student') {
        query.student = get(this.$auth.user.student, 'id')
      }
      this.getUniformOrdersRegisterByStudents(query)
    },
    toggleSelectAll(value) {
      this.selectedItems = value ? this.uniformOrderss.map(item => item.id) : []
    },
    async changeStatusForSelected() {
      if (!this.newStatus) {
        this.$alert.error('Vui lòng chọn trạng thái để cập nhật!')
        return
      }

      if (this.selectedItems.length === 0) {
        this.$alert.error('Vui lòng chọn ít nhất một đơn hàng để cập nhật!')
        return
      }

      this.itemsSkipped = this.selectedItems.filter(
        item => item.statusReturned === 'waiting_returned' || item.statusReturned === 'complete_returned'
      )

      this.itemsToUpdate = this.selectedItems.filter(item => !this.itemsSkipped.includes(item))

      this.confirmDialogSelect = true
    },
    async confirmChange() {
      this.confirmDialogSelect = false

      if (this.itemsToUpdate.length === 0) {
        this.$alert.error('Không có đơn hàng nào hợp lệ để cập nhật.')
        return
      }

      try {
        this.$loading.active = true
        await Promise.all(
          this.itemsToUpdate.map(async item => {
            await this.updateUniformOrders({
              id: item.id,
              status: this.newStatus,
            })
          })
        )

        this.confirmDialogSelectAlert = true
        // Thông báo sau khi cập nhật thành công
        // this.$dialog.alert({
        //   title: 'Thông báo',
        //   text: `Cập nhật thành công ${itemsToUpdate.length} / ${
        //     this.selectedItems.length
        //   } đơn hàng sang trạng thái "${this.getStatusText(this.newStatus)}".`,
        //   okText: 'Đóng',
        // })

        this.refresh()
      } catch (error) {
        this.$alert.addError('Đã xảy ra lỗi khi cập nhật trạng thái!')
      } finally {
        this.$loading.active = false
      }
    },

    onEdit(item) {
      this.editDialog = !this.editDialog
      this.selectedItem = item
    },
    onDetailOrder(item) {
      this.detailDialog = !this.detailDialog
      this.selectedItem = item
    },
    onConfirmStudentOrder(item) {
      this.confirmStudentDialog = !this.confirmStudentDialog
      this.selectedItem = item
    },
    onConfirmOrder(item) {
      this.confirmDialog = !this.confirmDialog
      this.selectedItem = item
    },
    onReviewOrder(item) {
      this.reviewDialog = !this.reviewDialog
      this.selectedItem = item
    },
    onShowHistory(item) {
      this.historyDialog = !this.historyDialog
      this.selectedItem = item
    },
    viewOrderDetail(id) {
      this.$router.push(`/uniform-orders-register/${id}`)
    },
    getStatusColor(status) {
      switch (status) {
        case 'pending':
          return '#FFA726'
        case 'confirmed':
          return '#4CAF50'
        case 'cancelled':
          return '#616161'
        default:
          return '#9E9E9E'
      }
    },
    getStatusReturnColor(statusReturned) {
      switch (statusReturned) {
        case 'not_returned':
          return '#FFA726'
        case 'waiting_returned':
          return '#FFC107'
        case 'complete_returned':
          return '#4CAF50'
        default:
          return '#9E9E9E'
      }
    },
    getStatusText(status) {
      return (
        {
          pending: 'Chờ duyệt',
          confirmed: 'Đã xác nhận',
          cancelled: 'Đã hủy',
        }[status] || 'Không xác định'
      )
    },
    getStatusReturnText(statusReturned) {
      return (
        {
          not_returned: 'Chưa trả',
          waiting_returned: 'Đang trả hàng',
          complete_returned: 'Đã hoàn thành',
        }[statusReturned] || 'Không xác định'
      )
    },
    formatCurrency(value) {
      return new Intl.NumberFormat('vi-VN', {
        style: 'currency',
        currency: 'VND',
      }).format(value)
    },
    onRemove(item) {
      this.$dialog.confirm({
        title: 'Thông báo xác nhận',
        text: 'Bạn có chắc muốn xóa đơn đăng ký đồng phục này? Bạn không thể hoàn tác hành động.',
        okText: 'OK',
        cancelText: 'Hủy',
        done: async () => {
          this.$loading.active = true
          try {
            await this.removeUniformOrders(item.id)
            this.$alert.deleteSuccess()
          } catch (error) {
            this.$alert.deleteError(error)
          } finally {
            this.$loading.active = false
          }
        },
      })
    },
  },
  computed: {
    ...mapState('UniformOrdersRegister', [
      'uniformOrderss',
      'totalItems',
      'pageText',
      'loading',
      'uniformOrdersSearchParams',
    ]),

    canDisplayByStudent() {
      return get(this.$auth.user, 'role.type') === 'student'
    },

    headers() {
      if (this.canDisplayByStudent) {
        return this.originHeaders.filter(h => !['student', 'student.dob', 'student.class'].includes(h.value))
      } else {
        return this.originHeaders.filter(h => !['orderedAt'].includes(h.value))
      }
    },
  },
}
</script>

<style lang="scss">
.image-wrapper {
  width: 55px;
  min-width: 55px;
  height: 40px;
  display: flex;
  align-items: center;
  border-radius: 4px;
  justify-content: center;
  img {
    max-width: 100%;
    max-height: 100%;
    border-radius: 4px;
  }
}
.table-cell-wrapper2 {
  padding-top: 4px !important; /* Căn lề 8px */
  padding-bottom: 4px !important;
  display: flex;
  align-items: flex-start; /* Căn theo top */
  justify-content: flex-start; /* Căn trái */
  height: 100%;
}
.table-cell-wrapper {
  padding-top: 10px !important; /* Căn lề 8px */
  padding-bottom: 6px !important;
  display: flex;
  align-items: flex-start; /* Căn theo top */
  justify-content: flex-start; /* Căn trái */
  height: 100%;
}
.text-start .v-simple-checkbox {
  padding-top: 10px !important; /* Căn lề 8px */
  padding-bottom: 6px !important;
  display: flex;
  align-items: flex-start; /* Căn theo top */
  justify-content: flex-start; /* Căn trái */
  height: 100%;
}
.text-start .v-simple-checkbox .mdi-checkbox-marked {
  color: #0d47a1 !important;
}
.text-start .v-simple-checkbox .mdi-minus-box {
  color: #0d47a1 !important;
}
@media (max-width: 1440px) {
  // // Header columns
  // .v-data-table thead th:nth-child(3),
  // .v-data-table thead th:nth-child(4),
  // // Body rows
  // .v-data-table tbody td:nth-child(3),
  // .v-data-table tbody td:nth-child(4) {
  //   display: none !important;
  // }
  .hide-student-columns {
    // Header columns
    thead th:nth-child(3),
    thead th:nth-child(4),
    // Body rows
    tbody td:nth-child(3),
    tbody td:nth-child(4) {
      display: none !important;
    }
  }
}
.hide-student-columns2 {
  // Header columns
  thead th:nth-child(1),
    // Body rows
    tbody td:nth-child(1) {
    display: none !important;
  }
}
</style>
